<template>
<div>
	<div class="custom-block tip">
    	<p class="custom-block-title">Importante</p>
    	<p>Los headers, diferentes a other, no les aplica validación de obligatoriedad.</p>
	</div>
    <table>
        <thead>
            <tr>
                <th>Tipo</th>
                <th>Especificación</th>
                <th>Descripción</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Other</td>
                <td>SESSIONID</td>
                <td>Identificador de la sesión</td>
            </tr>
            <tr>
                <td>Response Content Type</td>
                <td>application/json</td>
                <td>Formato de la respuesta</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>CHANNEL</td>
                <td>Identificador del canal en el que se está operando. 001 = WEB; 003 = Mobile</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>CORRELATIONID</td>
                <td>Identificador de correlación para identificar operaciones dentro de la misma sesión</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>LANG</td>
                <td>Lenguaje en el que se quiere consumir el servicio. ES = Español; EN = Inglés.</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>clientip</td>
                <td>
                    Dirección ip del cliente.<br/>
                    (opcional)
                </td>
            </tr>
            <tr>
                <td>Other</td>
                <td>X-TENANT-CODE</td>
                <td>ID/CODE del TENANT en el que se está operando</td>
            </tr>
            <tr>
                <td>Other</td>
                <td>encryptionKey</td>
                <td>Llave de encripción para cifrado de RQ y RS. Es utilizado únicamente cuando se tiene encendido el cifrado y aplica dentro de las apis de seguridad y después de la API de Generar Llave de Encripción.</td>
            </tr>
        </tbody>
    </table>
</div>
</template>
<script>
export default {
    name: 'HeadersTenant'
}
</script>
<style lang="css" scoped>
    table {
        margin: 0px;
    }
    table tr td:nth-child(1) {
        width: 10% !important;
    }
    table tr td:nth-child(2) {
        width: 10% !important;
    }
    table tr td:nth-child(3) {
        width: 30% !important;
    }
</style>